<script setup lang="ts">
import GearIcon from '@/assets/icons/core/gear.svg';
import RefreshButton from '@/modules/ui/components/buttons/RefreshButton.vue';

const { fixed = true, message } = defineProps<{
  fixed?: boolean;
  message?: string;
}>();
</script>

<template>
  <div
    class="error-wrap"
    :class="{ fixed: fixed }"
  >
    <div class="error-logo">
      <img
        src="/icons/logo.svg"
        alt="АЛЬФА ДОК"
      />
      <span>{{ $t('core.common.title') }}</span>
    </div>

    <p class="error-text">{{ message ?? $t('core.pages.error.reloadMessage') }}</p>

    <RefreshButton class="error-reload" />

    <div class="error-gears">
      <GearIcon class="gear large spin" />
      <GearIcon class="gear mid spinout" />
      <GearIcon class="gear small spinout" />
    </div>
  </div>
</template>

<style scoped>
.error-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;

  background-color: #fafafc;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    Segoe UI,
    Roboto,
    Helvetica Neue,
    Arial,
    Noto Sans,
    Liberation Sans,
    sans-serif,
    Apple Color Emoji,
    Segoe UI Emoji,
    Segoe UI Symbol,
    Noto Color Emoji;
}

.error-wrap.fixed {
  position: fixed;
  inset: 0;
  z-index: 1500;
}

.error-logo {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 1.5rem;
}

.error-logo img {
  width: 70px;
  height: 70px;
  margin-right: 8px;
}

.error-text {
  margin-bottom: 24px;
  text-align: center;
  font-size: 1.5rem;
  color: gray;
}

.error-reload {
  margin-bottom: 40px;
}

.error-gears {
  position: relative;
  width: 175px;
  height: 175px;
}

.gear {
  position: absolute;
  fill: rgba(0, 0, 0, 0.1);
}

.large {
  width: 130px;
  height: 130px;
  left: 0;
  bottom: 0;
}
.mid {
  width: 70px;
  height: 70px;
  right: 0;
  top: 0;
}
.small {
  width: 35px;
  height: 35px;
  right: 20px;
  bottom: 0;
}

.spin {
  animation: spin 5000ms linear infinite;
}
.spinout {
  animation: spinout 5000ms linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes spinout {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}
</style>
